"use client";

import { Card, CardContent } from "@/components/ui/card";
import { ChevronRight } from "lucide-react";
import { PreviewCardProps } from "@/types/gallery";
import normalizeAssetUrl from "../../../lib/assetUrl";
import { StaticImageData } from "next/image"; 

if (process.env.NODE_ENV !== "production") {
  // @ts-ignore
  if (typeof normalizeAssetUrl !== "function") {
    console.error("normalizeAssetUrl è undefined o non è una funzione!");
  }
}

const CARD_H = "h-[500px]";
const TITLE_MIN_H = "min-h-[56px]";
const DESC_MIN_H = "min-h-[66px]";

export default function PreviewCard({
	title,
	description = "Descrizione non disponibile",
	onClick,
	image,
	previewImage,
}: PreviewCardProps & { previewImage?: string }) {
	// 👇 Converti StaticImageData in string se necessario
	const imageUrl = typeof image === "string" 
		? image 
		: (image as StaticImageData)?.src;
	
	const coverUrl = previewImage || imageUrl 
		? normalizeAssetUrl(previewImage ?? imageUrl) 
		: null;

	return (
		<Card
			onClick={onClick}
			role="button"
			tabIndex={0}
			className={`px-4 py-8 cursor-pointer elegant-border rounded-xl group relative ${CARD_H} flex flex-col shadow-sm hover:shadow-md transition`}
			style={{
				backgroundColor: "var(--card)",
				color: "var(--card-foreground)",
			}}
		>
			<div className="side-border flex flex-col grow">
				<CardContent className="h-full flex flex-col gap-3 py-2">
					<h3
						className={`text-2xl font-bold line-clamp-2 break-word ${TITLE_MIN_H}`}
					>
						{title}
					</h3>

					<p
						className={`text-md text-(--foreground) line-clamp-5 break-word ${DESC_MIN_H} max-h-[130px]`}
					>
						{description}
					</p>

					<div className="mt-auto">
						<div className="w-full aspect-[16/9] rounded-lg overflow-hidden border border-(--bg-secondary) bg-(--bg-secondary)">
							{coverUrl ? (
								<img
									src={coverUrl}
									alt={`Preview di ${title}`}
									className="w-full h-full object-contain"
									decoding="async"
									onError={(e) => {
										(e.currentTarget as HTMLImageElement).style.display = "none";
									}}
								/>
							) : (
								<div className="w-full h-full flex items-center justify-center text-xs text-(--muted-foreground)">
									Nessuna immagine
								</div>
							)}
						</div>

						<div className="pt-3">
							<div className="flex items-center font-semibold text-md text-(--card-foreground) group-hover:underline">
								Scopri di più! <ChevronRight className="ml-1 w-4 h-4" />
							</div>
						</div>
					</div>
				</CardContent>
			</div>
		</Card>
	);
}